<template>
  <main-layout>
    <template #header>
      <main-header :title="'임대업체 관리' | translate">
        <template #btn-wrapper>
          <v-btn style="padding-left: 0" elevation="0" color="#F9FCFF" @click="openExcelWindow">
            <img :src="utilManager.getImgUrl(IMAGES.EXCEL)">
            엑셀 다운로드
          </v-btn>
        </template>
      </main-header>
      <search-bar
        v-model="searchOptions.searchKeyword"
        :placeholder="'업체명/업체코드/사업자번호/대표자명' | translate"
        style="width: 450px;"
      />
    </template>

    <template #feature />

    <template #toolbar>
      <main-toolbar>
        <search-single-select-box
          v-model="searchOptions.approvedYn"
          :items="approvedYnOptions"
          :label="'승인여부' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.useYn"
          :items="cmsUseYnOptions"
          :label="'사용여부' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.useAutoUsage"
          :items="cmsUseYnOptions"
          :label="'월별사용량' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.useAutoSales"
          :items="cmsUseYnOptions"
          :label="'매출자동' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.useAutoCms"
          :items="cmsUseYnOptions"
          :label="'CMS 자동' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.useAutoTax"
          :items="taxYnOptions"
          :label="'세금계산서 자동' | translate"
          style="max-width: 160px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.cmsUseYn"
          :items="cmsUseYnOptions"
          :label="'CMS사용' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.taxYn"
          :items="taxYnOptions"
          :label="'세금계산서' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
            v-model="searchOptions.ntsTaxYn"
            :items="taxYnOptions"
            :label="'국세청사용' | translate"
            style="max-width: 125px;"
            @update:selected="onFilterChanged"
        />
        <search-single-select-box
            v-model="searchOptions.kakaoTalkYn"
            :items="taxYnOptions"
            :label="'알림톡사용' | translate"
            style="max-width: 125px;"
            @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.actualYn"
          :items="taxYnOptions"
          :label="'실사용자' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-multi-select-box
          v-model="searchOptions.rentalcompanyGroups"
          :items="rentalCompanyGroupOptions"
          :label="'임대업체 그룹' | translate"
          style="max-width: 200px;"
          @update:selected="onFilterChanged"
        />
      </main-toolbar>
    </template>

    <template #body>
      <main-body>
        <base-table
          class="membership-table"
          :headers="headers" :is-loading="isLoading" :items="convertItems" :items-total-count="itemsTotalCount"
          :infinity-scroll="infinityScroll"
          :sort-option="sortOption"
          :page-number="searchOptions.pageNumber"
          :page-length="pageLength"
          :item-numbering="true"
          @on-page-change="e => onLoad(e)"
          @on-sort-change="onSortChange"
        >
          <template #item.planName="{ item }">
            <div
              class="plan-cell"
              :title="item.planName || '설정 없음'"
              @click.stop="onClickPlanItem(item)"
            >
              {{ item.planName || '설정 없음' }}
            </div>
          </template>
          <template #item.grantBankAccount="{ item }">
            <div
                class="plan-cell button_style center"

                :title="'권한부여'"
                @click.stop="onClickGrantBankAccount(item)"
            >
              {{ '권한부여' }}
            </div>
          </template>
          <template #item.cmsMemberCnt="{ item }">
            <div
              class="plan-cell text-center d-block"
              :title="item.cmsMemberCnt || '-'"
              @click.stop="onClickMemberItem(item)"
            >
              {{ item.cmsMemberCnt || '-' }}
            </div>
          </template>
        </base-table>

        <v-dialog
          ref="plan-dialog"
          v-model="planDialogShow"
          width="1000px"
          max-width="1000px"
          persistent
        >
          <rentalcompany-plan-detail
            v-if="selectedItem"
            :title="!!selectedItem && !!selectedItem.rentalcompanyName ?
                `요금제 - ${selectedItem.rentalcompanyName} - ` : undefined"
            :item="selectedItem"
            :base-plan-items="basePlanItems"
            :sub-item-codes="subItemCodes"
            @close="closeDetailDialog"
            @save="onSavePlanItem"
          />
        </v-dialog>

        <v-dialog
          ref="cms-dialog"
          v-model="cmsDialogShow"
          width="990px"
          max-width="1000px"
          persistent
        >
          <cms-plan-detail
            v-if="selectedItem"
            :title="!!selectedItem && !!selectedItem.rentalcompanyName ?
                  `${selectedItem.rentalcompanyName} | CMS` : undefined"
            :item="selectedItem"
            :cms-bank-codes="cmsBankCodes"
            @close="closeDetailDialog"
            @init="initPage"
          />
        </v-dialog>
        <v-dialog
            ref="plan-dialog"
            v-model="bankAccountDialogShow"
            width="1000px"
            max-width="1000px"
            persistent
        >
          <grant-bank-account-dialog
              v-if="bankAccountSearchItem"
              :item="bankAccountSearchItem"

              @closeBankAccount="closeGrantBankAccountDialog"
              @save="onSavePlanItem"
          />
        </v-dialog>
      </main-body>
    </template>
  </main-layout>
</template>

<script>
import MainLayout from "@/components/common/layout/MainLayout";
import MainBody from "@/components/common/layout/MainBody";
import MainToolbar from "@/components/common/layout/MainToolbar";
import MainHeader from "@/components/common/layout/MainHeader";
import {PATH} from "@/constants";
import {RentalCompany} from "@/model/rental-company";
import TotalCodeOptions from "@/assets/options/TotalCodeOptions";
import SearchSingleSelectBox from "@/components/input/SearchSingleSelectBox";
import SearchBar from "@/components/input/new/SearchBar";
import BaseTable from "../../components/common/newBase/InfinityScrollTable.vue";
import Headers from "../../components/common/newBase/Headers.vue";
import SearchMultiSelectBox from "@/components/input/SearchMultiSelectBox.vue";
import {IMAGES} from "@/constants/icons";
import ExcelDownloadMembershipList from "@/framework/excel/ExcelDownloadMembershipList";
import RentalcompanyPlanDetail from "../../components/payment/RentalcompanyPlanDetail.vue";
import {cloneDeep} from "lodash";
import {DateTime} from "luxon";
import CmsPlanDetail from "../../components/payment/CmsMemberDetail.vue";
import GrantBankAccountDialog from "@/components/modal/GrantBankAccountDialog.vue";

export default {
  name: "MembershipList",
  components: {
    GrantBankAccountDialog,
    CmsPlanDetail,
    RentalcompanyPlanDetail,
    SearchMultiSelectBox,
    BaseTable,
    MainToolbar,
    MainHeader,
    MainBody,
    MainLayout,
    SearchBar,
    SearchSingleSelectBox
  },
  extends: Headers,
  mixins: [TotalCodeOptions],
  data() {
    return {
      headers: [],
      searchOptions: {
        useYn: null,
        useAutoUsage: null,
        useAutoSales: null,
        useAutoCms: null,
        useAutoTax: null,
        cmsUseYn: null,
        startDate: null,
        endDate: null,
        searchKeyword: null,
        gpCdList: null,
        countryCodeList: null,
        approvedYn: null,
        taxYn: null,
        kakaoTalkYn: null,
        ntsTaxYn: null,
        actualYn: 'Y',
        rentalcompanyGroups: [],
        pageNumber: 1,
        pageSize: 100,
      },
      sortOption: {
        sortBy: ['rentalcompanyId'],
        sortDesc: ['true'],
      },
      infinityScroll: true,
      items: [],
      itemsTotalCount: undefined,
      isLoading: false,

      rentalCompanyGroupOptions: [],

      selectedItem: undefined,
      // 요금제
      planDialogShow: false,
      subItemCodes: [],
      basePlanItems: [],

      // CMS
      cmsDialogShow: false,
      cmsBankCodes: [],
      // 계좌 거래 내역 조회
      bankAccountDialogShow: false,
      bankAccountSearchItem: undefined,
    }
  },

  computed: {
    IMAGES() {
      return IMAGES
    },
    pageLength() {
      if (!this.itemsTotalCount) return 1
      return Math.ceil(this.itemsTotalCount / this.searchOptions.pageSize)
    },

    /**
     * 목록 데이터에서 groupNamesText 를 나누어 groupNames 에 할당하고 반환합니다.
     * @param items
     * @returns {*}
     */
    convertItems() {
      return this.items.map(e => {
        return {
          ...e,
          groupNames: e.groupNamesText ? e.groupNamesText.split(',') : []
        }
      })
    },
  },

  watch: {
    'searchOptions.searchKeyword': {
      handler(newValue, oldValue) {
        this.onLoad(1)
      }
    },
  },


  mounted() {
    this.loadPlanCodes()
    this.loadApprovedYnOptions();
    this.loadCmsUseYnOptions();
    this.loadTaxYnOptions();
    this.loadRentalCompanyGroupOptions();
    this.headers = this.membershipHeaders
    this.initPage()
    this.loadPlanData()
    this.loadBankCodes()
  },

  methods: {
    initPage() {
      this.searchOptions.pageNumber = 1;
      this.itemsTotalCount = undefined
      this.items = []
      this.loadData();
    },

    async loadData() {
      if (this.isLoading) return
      try {
        this.isLoading = true
        const res = await this.$request(PATH.MEMBERSHIP.LIST)
          .setObject(
            {...this.searchOptions, ...this.sortOption}
          ).catch(e => {
            alert('Error')
          })
          .enqueue()

        this.itemsTotalCount = res.dataTotalCount
        this.items.push(...res.data)
        this.isLoading = false
      } catch (e) {
        alert('Error')
      }
    },

    onSortChange(option) {
      Object.keys(option).forEach(e => {
        this.sortOption[e] = option[e]
      })
      this.onFilterChanged()
    },

    onFilterChanged() {
      this.onLoad(1)
    },

    onLoad(pageNumber) {
      this.searchOptions.pageNumber = pageNumber
      if (!this.infinityScroll || pageNumber === 1)
        this.items.splice(0, this.items.length)
      this.loadData()
    },

    // 기존 모델로 반환
    newRentalCompany(e) {
      return new RentalCompany(e)
    },

    onClickItem(item) {

    },

    async onApproveRentalCompany(item) {
      this.$confirm(`확인을 누르면 [${item.rentalcompanyName}]에게 승인메일이 발송 됩니다.`).then(async () => {
        try {
          const path = item.approvedYn === 'Y' ? PATH.MEMBERSHIP.REAPPROVE : PATH.MEMBERSHIP.APPROVE
          const res = await this.$request(path)
            .setObject({rentalcompanyId: item.rentalcompanyId})
            .catch()
            .enqueue()
          this.items.find(e => e.rentalcompanyId === item.rentalcompanyId).approvedYn = 'Y'
          if (!!res) {
            alert('메일 발송 완료')
          }
        } catch (e) {
          alert('에러발생')
          this.initPage()
        }
      })
    },

    async onUpdateRentalCompanyConfig(type, item) {
      this.$confirm(`확인을 누르면 [${item.rentalcompanyName}]의 설정이 변경 됩니다.`).then(async () => {
        try {
          const res = await this.$request(PATH.MEMBERSHIP.UPDATE_AUTO_STATUS, item.rentalcompanyId, type)
            .catch()
            .enqueue()
          this.items.find(e => e.rentalcompanyId === item.rentalcompanyId)[type] = res
        } catch (e) {
          alert('에러발생')
          this.initPage()
        }
      })
    },

    onRentalcompanyActualClick(item) {
      item.actualYn = item.actualYn === 'Y' ? 'N' : 'Y'
      this.onUpdateRentalCompanyInfo(item)
    },
    onKakaoTalkYnClick(item) {
      item.kakaoTalkYn = item.kakaoTalkYn === 'Y' ? 'N' : 'Y'
      this.onUpdateRentalCompanyInfo(item)
    },
    onBarobillYnClick(item) {
      item.barobillYn = item.barobillYn === 'Y' ? 'N' : 'Y'
      this.onUpdateRentalCompanyInfo(item)
    },
    onNtsTaxYnClick(item) {
      item.ntsTaxYn = item.ntsTaxYn === 'Y' ? 'N' : 'Y'
      this.onUpdateRentalCompanyInfo(item)
    },

    async onUpdateRentalCompanyInfo(item) {
      try {
        await this.$request(PATH.MEMBERSHIP.UPDATE_INFO)
          .setObject(item)
          .catch()
          .enqueue()
        const updateItem = this.items.find(e => e.rentalcompanyId === item.rentalcompanyId)
        Object.keys(item).forEach(e => updateItem[e] = item[e])
      } catch (e) {
        alert('에러발생')
        this.initPage()
      }
    },

    /**
     * 임대업체 그룹목록을 타이틀 문자열로 표시합니다.
     * @param groups
     * @returns {*|string}
     */
    rentalCompanyGroupsToTitle(groups) {
      if (!groups) return '-'

      return groups.join(', ')
    },

    openExcelWindow() {
      this.$confirm(this.$translate('엑셀 다운로드를 하시겠습니까?')).then(
        () => {
          const excel = new ExcelDownloadMembershipList()
          const searchOptions = {}
          this.$cloneDeep(this.searchOptions, searchOptions)

          excel.searchOptions = searchOptions
          excel.exportToExcel()
        }
      )
    },


    /**
     * 요금제 목록 조회
     * @return {Promise<void>}
     */
    async loadPlanData() {
      this.basePlanItems.splice(0, this.basePlanItems.length)
      const res = await this.$request(PATH.MPS_PLAN.BASE_LIST)
        .setObject({
          pageSize: 2000,
          pageNumber: 1,
        })
        .catch(e => {
          console.error(e)
        })
        .enqueue()
      this.basePlanItems.push(...res.data)
    },

    /**
     * 요금제의 하위 설정 값을 조회
     * @return {Promise<void>}
     */
    async loadPlanCodes() {
      this.subItemCodes.splice(0, this.subItemCodes.length)
      const res = await this.$request(PATH.MPS_PLAN.SUB_CODE_LIST)
        .setObject({})
        .catch(e => {
          console.error(e)
        })
        .enqueue()
      this.subItemCodes.push(...res.data)
    },

    // =====================================요금제 START==========================================
    onClickPlanItem(item) {
      this.selectedItem = item
      this.planDialogShow = true
    },
    onClickGrantBankAccount(item) {
      if(item.barobillYn === 'N') {
        this.$alert('해당 업체에 계좌 거래 내역 조회 기능 활성화가 필요합니다.')
        return
      }
      this.bankAccountSearchItem = item
      this.bankAccountDialogShow = true
    },
    closeGrantBankAccountDialog() {
      this.bankAccountSearchItem = undefined
      this.bankAccountDialogShow = false
    },
    async onGrantPermission(param) {
      const res = await this.$request(PATH.USER_PERMISSION.USER_CHECK)
          .setObject(param)
          .catch(e => {
            console.error(e)
          })
          .enqueue()

      if (res) {
        this.$toasted.success('저장했습니다.')
        this.closeDetailDialog()
        this.initPage()
      }

    },
    async onSavePlanItem(editContext) {
      if (!confirm('저장하시겠습니까?'))
        return

      const param = cloneDeep(editContext)

      param.planItems = param.planItems.filter(e => e.deleteYn !== 'Y')
      param.planItems.forEach(e => {
        if (e.holdDatetime && e.holdDatetime !== '') {
          e.holdDatetime = DateTime.fromFormat(e.holdDatetime, 'yyyy-MM-dd').startOf('day').toISO()
        }
      })

      const res = await this.$request(PATH.MPS_PLAN.RENTALCOMPANY_PLAN_INSERT)
        .setObject(param)
        .catch(e => {
          console.error(e)
        })
        .enqueue()

      if (res) {
        this.$toasted.success('저장했습니다.')
        this.closeDetailDialog()
        this.initPage()
      }
    },
    // =====================================요금제 END==========================================

    // =====================================CMS정보 START==========================================
    onClickMemberItem(item) {
      this.selectedItem = item
      this.cmsDialogShow = true
    },

    async onCmsRegister(editContext) {

    },

    async onCmsUpdate(editContext) {

    },

    async onCmsDelete(editContext) {

    },

    async onCmsSimpleRegister(editContext) {

    },

    async onCmsSimpleCancel(editContext) {

    },

    async loadBankCodes() {
      const res = await this.$request(PATH.CMS_MEMBER.BANK_CODE)
        .catch(e => {
          console.error(e)
        })
        .enqueue()
      this.cmsBankCodes.splice(0, this.cmsBankCodes.length)
      this.cmsBankCodes.push(...res.data)
    },
    // =====================================CMS정보 END==========================================


    closeDetailDialog() {
      this.selectedItem = undefined
      this.planDialogShow = false
      this.cmsDialogShow = false
    },

    conractEndCheckClass(v) {
      try {
        let result = ''

        const target = this.$parseDate(v).diffNow('months')
        if ( target.months < 0 ){
          result = 'deadline-timeover'
        } else if (target.months <= 1) {
          result = 'deadline-1-month'
        } else if (target.months <= 2) {
          result = 'deadline-2-month'
        } else if (target.months <= 3) {
          result = 'deadline-3-month'
        } else if (target.months <= 6) {
          result = 'deadline-6-month'
        } else {
          result = 'deadline-6-month-over'
        }
        return result
      } catch (e) {
        return ''
      }
    },

    async onLoadRecentLogin(item) {

      const res = await this.$request(PATH.MEMBERSHIP.GET_LAST_LOGIN)
        .setObject({
          rentalcompanyId: "" + item.rentalcompanyId
        })
        .catch(e => {
          console.error(e)
        })
        .enqueue()

      if (!!res) {
        const idx = this.items.findIndex(e => { return String(e.rentalcompanyId) === String(item.rentalcompanyId)})
        if (idx >= 0) {
          this.items[idx].lastLoginDatetime = res
        }
      }
    },
  },
}
</script>

<style scoped>
.button_style {
  border: 1px solid #ddd;
  width: 100%;
  height: 100%;
  background-color: #0085FF;
  color: white;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center
}
.vue-data-table >>> .v-data-table__wrapper > table > thead > tr > th {
  font-size: 0.6rem;
  height: 20px;
}

.item--cell {
  height: 25px;
}

.short-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

}

.address-column {
  padding: 8px;
  height: 100%;
  width: 300px;
}

.rentalcompanyName-column {
  width: 150px;
}

.userFullname-column {
  width: 80px;
}

.ceoFullname-column {
  width: 80px;
}

.v-input {
  font-size: 1rem !important;
}

.plan-cell {
  cursor: pointer;
  display: inline-block;
  height: 26px;
  max-width: 100%;
  line-height: 26px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.plan-cell:hover {
  color: #DCEDFD;
  font-weight: bold;
}

.membership-table .deadline-timeover {
  background: rgb(255, 128, 128);
  color: white;
}

.membership-table .deadline-1-month {
  background: rgb(188, 188, 85);
  color: white;

}

.membership-table .deadline-2-month {
  background: rgb(85,85,188);
  color: white;

}

.membership-table .deadline-3-month {
  background: rgb(85, 188, 85);
  color: white;

}

.membership-table .deadline-6-month {
  background: rgb(238, 238, 238);

}

.membership-table.deadline-6-month-over {

}
</style>
